import { useEffect, useRef, useState } from 'react';

const images = [
  {
    src: 'https://readdy.ai/api/search-image?query=elegant%20perfume%20bottle%20collection%20on%20marble%20surface%20warm%20golden%20light%20minimalist%20luxury%20fragrance%20design%20glass%20and%20gold%20details&width=600&height=450&seq=about-gallery-1&orientation=landscape',
    alt: 'Colección de insumos para perfumería',
    className: 'aspect-[4/3]',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=natural%20essential%20oil%20extraction%20process%20copper%20still%20apparatus%20botanical%20herbs%20warm%20rustic%20elegant%20distillery%20atmosphere%20soft%20light&width=600&height=450&seq=about-gallery-2&orientation=landscape',
    alt: 'Destilación de esencias',
    className: 'aspect-[3/4]',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=close%20up%20of%20blooming%20jasmine%20flowers%20in%20soft%20morning%20light%20delicate%20petals%20natural%20perfume%20ingredients%20elegant%20botanical%20beauty&width=600&height=450&seq=about-gallery-3&orientation=landscape',
    alt: 'Ingredientes naturales',
    className: 'aspect-[3/4]',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=modern%20logistics%20warehouse%20with%20shelves%20of%20glass%20perfume%20bottles%20warm%20ambient%20light%20professional%20distribution%20center%20elegant%20storage&width=600&height=450&seq=about-gallery-4&orientation=landscape',
    alt: 'Centro de distribución de insumos',
    className: 'aspect-[4/3]',
  },
];

function useVisible() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return { visible, ref };
}

export default function GallerySection() {
  const { visible, ref } = useVisible();

  return (
    <section ref={ref} className="py-24 md:py-32 px-6 md:px-16 lg:px-24 bg-[#f5f2ed]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-20">
          <p className="text-xs uppercase tracking-[0.25em] text-gray-400 mb-4">Nuestro Mundo</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">El Arte de la Perfumeria Fina</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {images.map((img, i) => (
            <div
              key={img.alt}
              className={`overflow-hidden rounded-lg transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <div className={img.className}>
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}